import { tracked } from "@glimmer/tracking";
import { action } from "@ember/object";
import Service, { service } from "@ember/service";
import { focusSearchInput } from "discourse/components/search-menu";
import { disableImplicitInjections } from "discourse/lib/implicit-injections";
const Search = dt7948.c(class Search extends Service {
  static #_ = (() => dt7948.g(this.prototype, "appEvents", [service]))();
  #appEvents = (() => (dt7948.i(this, "appEvents"), void 0))();
  static #_2 = (() => dt7948.g(this.prototype, "activeGlobalSearchTerm", [tracked], function () {
    return "";
  }))();
  #activeGlobalSearchTerm = (() => (dt7948.i(this, "activeGlobalSearchTerm"), void 0))();
  static #_3 = (() => dt7948.g(this.prototype, "searchContext", [tracked]))();
  #searchContext = (() => (dt7948.i(this, "searchContext"), void 0))();
  static #_4 = (() => dt7948.g(this.prototype, "highlightTerm", [tracked]))();
  #highlightTerm = (() => (dt7948.i(this, "highlightTerm"), void 0))();
  static #_5 = (() => dt7948.g(this.prototype, "inTopicContext", [tracked], function () {
    return false;
  }))();
  #inTopicContext = (() => (dt7948.i(this, "inTopicContext"), void 0))();
  static #_6 = (() => dt7948.g(this.prototype, "visible", [tracked], function () {
    return false;
  }))();
  #visible = (() => (dt7948.i(this, "visible"), void 0))();
  static #_7 = (() => dt7948.g(this.prototype, "results", [tracked], function () {
    return {};
  }))();
  #results = (() => (dt7948.i(this, "results"), void 0))();
  static #_8 = (() => dt7948.g(this.prototype, "noResults", [tracked], function () {
    return false;
  }))();
  #noResults = (() => (dt7948.i(this, "noResults"), void 0))();
  // only relative for the widget search menu
  searchContextEnabled = false; // checkbox to scope search

  get contextType() {
    return this.searchContext?.type || null;
  }

  // The need to navigate with the keyboard creates a lot shared logic
  // between multiple components
  //
  // - SearchTerm
  // - Results::AssistantItem
  // - Results::Types
  // - Results::MoreLink
  // - Results::RecentSearches
  //
  // To minimize the duplicate logic we will create a shared action here
  // that can be reused across all of the components
  handleResultInsertion(e) {
    if (e.keyCode === 65 /* a or A */) {
      // add a link and focus composer if open
      if (document.querySelector("#reply-control.open")) {
        this.appEvents.trigger("composer:insert-text", document.activeElement.href, {
          ensureSpace: true
        });
        this.appEvents.trigger("header:keyboard-trigger", {
          type: "search"
        });
        document.querySelector("#reply-control.open textarea").focus();
        e.stopPropagation();
        e.preventDefault();
        return false;
      }
    }
  }
  static #_9 = (() => dt7948.n(this.prototype, "handleResultInsertion", [action]))();
  handleArrowUpOrDown(e) {
    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      let focused = e.target.closest(".search-menu") ? e.target : null;
      if (!focused) {
        return;
      }
      let links = document.querySelectorAll(".search-menu .results a");
      let results = document.querySelectorAll(".search-menu .results .search-link");
      if (!results.length) {
        return;
      }
      let prevResult;
      let result;
      links.forEach(item => {
        if (item.classList.contains("search-link")) {
          prevResult = item;
        }
        if (item === focused) {
          result = prevResult;
        }
      });
      let index = -1;
      if (result) {
        index = Array.prototype.indexOf.call(results, result);
      }
      if (index === -1 && e.key === "ArrowDown") {
        // change focus from the search input to the first result item
        const firstResult = results[0] || links[0];
        firstResult.focus();
      } else if (index === 0 && e.key === "ArrowUp") {
        focusSearchInput();
      } else if (index > -1) {
        // change focus to the next result item if present
        index += e.key === "ArrowDown" ? 1 : -1;
        if (index >= 0 && index < results.length) {
          results[index].focus();
        }
      }
      e.stopPropagation();
      e.preventDefault();
      return false;
    }
  }
  static #_10 = (() => dt7948.n(this.prototype, "handleArrowUpOrDown", [action]))();
}, [disableImplicitInjections]);
export default Search;